export default __webpack_public_path__ + "static/UG_logo_RGB_podstawowy_pozytyw_PL-967dae6dd0c67905365eb747306f1c06.jpg";